import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import 'gantt-task-react/dist/index.css';
import useNonceStyle from '@/utils/useNonceStyle';
const styles = {
    wrapper: '_3ZbQT',
    row: '_34SS0',
    cell: '_3lLk3',
    nameWrapper: '_nI1Xw',
    expander: '_2QjE6',
    emptyExpander: '_2TfEi'
};
const dateTimeOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
};
const TaskListTableFr = ({ rowHeight, rowWidth, fontFamily, fontSize, locale, tasks, onExpanderClick }) => {
    const format = useMemo(() => (date) => date.toLocaleDateString(locale, dateTimeOptions), [locale]);
    const fontClass = useNonceStyle({ fontFamily, fontSize });
    const rowClass = useNonceStyle({ height: `${rowHeight}px` });
    const cellWidthClass = useNonceStyle({ minWidth: rowWidth, maxWidth: rowWidth });
    return (_jsx("div", { className: `${styles.wrapper} ${fontClass}`, children: tasks.map(t => {
            let expanderSymbol = '';
            if (t.hideChildren === false) {
                expanderSymbol = '▼';
            }
            else if (t.hideChildren === true) {
                expanderSymbol = '▶';
            }
            return (_jsxs("div", { className: `${styles.row} ${rowClass}`, children: [_jsx("div", { className: `${styles.cell} ${cellWidthClass}`, title: t.name, children: _jsxs("div", { className: styles.nameWrapper, children: [_jsx("div", { className: expanderSymbol ? styles.expander : styles.emptyExpander, onClick: () => onExpanderClick(t), children: expanderSymbol }), _jsx("div", { children: _jsx(Link, { to: `/tasks/${t.id}`, children: t.name }) })] }) }), _jsxs("div", { className: `${styles.cell} ${cellWidthClass}`, children: ["\u00A0", format(t.start)] }), _jsxs("div", { className: `${styles.cell} ${cellWidthClass}`, children: ["\u00A0", format(t.end)] })] }, t.id + 'row'));
        }) }));
};
export default TaskListTableFr;
